import { useEffect } from 'react';
import { drawsOwnLoadFailure } from 'store/api/portalAPI';
import { useGetInvoiceCommentsQuery } from 'store/api/invoiceComments';

const POLL_MS = 45_000;

/**
 * An invoice's comments, polled and read again when the window gets focus. The page's Comments button and the
 * drawer share the one cache entry. A failed read raises no toast: the view draws its own error state and
 * the button just shows no count, while a poll that fails every 45 seconds would toast every time.
 */
export function useInvoiceComments(invoiceId: number, skip = false) {
    useEffect(() => (skip ? undefined : drawsOwnLoadFailure('getInvoiceComments', invoiceId)), [invoiceId, skip]);
    return useGetInvoiceCommentsQuery(invoiceId, { skip, pollingInterval: POLL_MS, refetchOnFocus: true });
}
